import { call, takeEvery, put } from "redux-saga/effects";

import {
  FETCH_QUESTIONS,
  FETCH_QUESTION,
  CREATE_QUESTION,
  UPDATE_QUESTION,
  DELETE_QUESTION,
  UPLOAD_QUESTIONS,
  COUNT_QUESTIONS,
} from "./actionTypes";

import {
  fetchQuestions,
  fetchQuestionsSuccess,
  fetchQuestionsFailure,
  fetchQuestionSuccess,
  fetchQuestionFailure,
  createQuestionSuccess,
  createQuestionFailure,
  updateQuestionSuccess,
  updateQuestionFailure,
  deleteQuestionSuccess,
  deleteQuestionFailure,
  uploadQuestionsSuccess,
  uploadQuestionsFailure,
  countQuestionsSuccess,
  countQuestionsFailure,
  countQuestions,
} from "./action";

import {
  fetchAllQuestions,
  fetchQuestionById,
  createQuestion,
  updateQuestion,
  deleteQuestion,
  uploadFileQuestions,
  countAllQuestions,
  countAllAssessments,
} from "../../helpers/backend_helper";

import { toast } from "react-toastify";

function* workFetchQuestions() {
  try {
    const response = yield call(fetchAllQuestions);
    yield put(fetchQuestionsSuccess(response.data));
  } catch (error) {
    yield put(fetchQuestionsFailure(error));
  }
}

function* workFetchQuestion({ payload }) {
  const { id } = payload;
  try {
    const response = yield call(fetchQuestionById, id);
    yield put(fetchQuestionSuccess(response.data));
  } catch (error) {
    yield put(fetchQuestionFailure(error));
  }
}

function* workCreateQuestion({ payload }) {
  const { data } = payload;
  try {
    const response = yield call(createQuestion, data);
    yield put(createQuestionSuccess(response.data));
    toast.success("Question created successfully!");
    yield put(fetchQuestions());
  } catch (error) {
    yield put(createQuestionFailure(error));
    toast.error("Failed to create the question.");
    console.error("Error creating question:", error);
  }
}

function* workUpdateQuestion({ payload }) {
  const { questionId, questionData } = payload;
  try {
    const response = yield call(updateQuestion, questionId, questionData);
    yield put(updateQuestionSuccess(response.data));
    toast.success("Question updated successfully!");
    yield put(fetchQuestions());
  } catch (error) {
    yield put(updateQuestionFailure(error));
    toast.error("Failed to update the question.");
    console.error("Error updating question:", error);
  }
}

function* workDeleteQuestion({ payload }) {
  const { id } = payload;
  try {
    const response = yield call(deleteQuestion, id);
    yield put(deleteQuestionSuccess(response.data));
    toast.success("Question deleted successfully!");
    yield put(fetchQuestions());
  } catch (error) {
    yield put(deleteQuestionFailure(error));
    toast.error("Failed to delete the question.");
  }
}

function* workUploadQuestions({ payload }) {
  const { data } = payload;
  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  };
  try {
    const response = yield call(uploadFileQuestions, data, config);
    yield put(uploadQuestionsSuccess(response.data));
    toast.success("Successfully uploaded questions.");
    yield put(fetchQuestions());
  } catch (error) {
    yield put(uploadQuestionsFailure(error));
    toast.error("Failed to upload questions.");
  }
}

function* workCountQuestions() {
  try {
    const response = yield call(countAllQuestions);
    yield put(countQuestionsSuccess(response.data));
  } catch (error) {
    yield put(countQuestionsFailure(error));
    toast.error("Failed to count questions.");
  }
}

export default function* watchFetchQuestionBankSaga() {
  yield takeEvery(FETCH_QUESTIONS, workFetchQuestions);
  yield takeEvery(FETCH_QUESTION, workFetchQuestion);
  yield takeEvery(CREATE_QUESTION, workCreateQuestion);
  yield takeEvery(UPDATE_QUESTION, workUpdateQuestion);
  yield takeEvery(DELETE_QUESTION, workDeleteQuestion);
  yield takeEvery(UPLOAD_QUESTIONS, workUploadQuestions);
  yield takeEvery(COUNT_QUESTIONS, workCountQuestions);
}
